import React, { FC, ComponentProps } from 'react';

import carleaseOverviewFirst from '@/newcar/ui/top/img/carleaseOverview/carleaseOverview1.png';
import carleaseOverviewFirstAvif from '@/newcar/ui/top/img/carleaseOverview/carleaseOverview1.avif';
import carleaseOverviewSecond from '@/newcar/ui/top/img/carleaseOverview/carleaseOverview2.png';
import carleaseOverviewSecondAvif from '@/newcar/ui/top/img/carleaseOverview/carleaseOverview2.avif';
import carleaseOverviewThird from '@/newcar/ui/top/img/carleaseOverview/carleaseOverview3.png';
import carleaseOverviewThirdAvif from '@/newcar/ui/top/img/carleaseOverview/carleaseOverview3.avif';

import * as styles from '@/newcar/ui/top/template/index.module.styl';
import * as stylesOverview from '@/newcar/ui/top/organism/CarleaseOverview.module.styl';

const CarleaseOverview: FC<{} & ComponentProps<'section'>> = ({ className }) => (
  <section id="CarleaseOverview" className={className}>
    <div className="has-background-light-yellow">
      <div className={`${stylesOverview.carleaseOverviewContainer} is-relative container`}>
        <h2
          className={`${styles.big} ${styles.commonTitle} ${styles.contentsTitle} ${styles.isOverview}`}
        >
          カーリースとは？
        </h2>
        <h3 className={stylesOverview.carleaseOverviewHeading}>
          毎月定額料金で、車を
          <br className="is-hidden-desktop" />
          ご利用できるサービスです
        </h3>
        <p className={stylesOverview.carleaseOverviewDescription}>
          カーリースとは、一定期間に渡って定額の料金で車を賃貸することができるサービスです。
          <br />
          ご利用料金には、重量税・自賠責保険料・車検代やメンテナンス費用も含まれていることが多く、自動車にかかる急な出費を抑えることができます。
        </p>

        <div className={stylesOverview.carleaseOverviewCardContainer}>
          <div className={stylesOverview.carleaseOverviewCardItem}>
            <h3 className={stylesOverview.carleaseOverviewCardHeading}>
              マイカー感覚で
              <br className="is-hidden-desktop" />
              自由に乗れる
            </h3>
            <picture>
              <source srcSet={carleaseOverviewFirstAvif} type="image/avif" />
              <img
                src={carleaseOverviewFirst}
                alt="マイカー感覚で自由に乗れる"
                loading="lazy"
                width="291"
                height="160"
              />
            </picture>
            <p className={stylesOverview.carleaseOverviewCardText}>
              車とご利用期間を選び、期間満了まで
              <span className="has-text-weight-bold">ご自分だけの車として自由に乗ることができます。</span>
              <br />
              レンタカーやカーシェアとは異なり、
              <span className="has-text-weight-bold">新車を独占して使用できる</span>
              ほか、レンタカーのように「わ」「れ」ナンバーにはなりません。
              <br />
              定額カルモくんの場合は、
              <span className="has-text-weight-bold">7年以上のご契約なら走行距離の制限はありません。</span>
            </p>
          </div>

          <div className={stylesOverview.carleaseOverviewCardItem}>
            <h3 className={stylesOverview.carleaseOverviewCardHeading}>
              利用期間が
              <br className="is-hidden-desktop" />
              満了したら
            </h3>
            <picture>
              <source srcSet={carleaseOverviewSecondAvif} type="image/avif" />
              <img
                src={carleaseOverviewSecond}
                alt="利用期間が満了したら"
                loading="lazy"
                width="290"
                height="160"
              />
            </picture>
            <p className={stylesOverview.carleaseOverviewCardText}>
              利用期間が満了した場合、一般的に以下からお選びいただけます。
              <br />
              ①同一車両で賃貸期間を延長（再リース）
              <br />
              ②車両を返却する（賃貸期間満了）
              <br />
              ③他の車両にて契約変更（お乗り換え）
              <br />
              ④車を購入する
              <br />
              定額カルモくんの場合は「
              <a className={stylesOverview.carleaseOverviewCardTextLink} href="/docs/moraeru/">もらえるオプション</a>
              」を追加することで、
              <span className="has-text-weight-bold">最後に「車をもらう」こともできます。</span>
            </p>
          </div>

          <div className={stylesOverview.carleaseOverviewCardItem}>
            <h3 className={stylesOverview.carleaseOverviewCardHeading}>
              カーリースの
              <br className="is-hidden-desktop" />
              <span className="is-hidden-mobile">料金の</span>
              仕組み
            </h3>
            <picture>
              <source srcSet={carleaseOverviewThirdAvif} type="image/avif" />
              <img
                src={carleaseOverviewThird}
                alt="カーリースの料金の仕組み"
                loading="lazy"
                width="342"
                height="160"
              />
            </picture>
            <p className={stylesOverview.carleaseOverviewCardText}>
              カーリースの料金は、車両代から残価やお値引き分を差し引いた価格を、
              <span className="has-text-weight-bold">利用期間に応じて分割してお支払い</span>
              いただく仕組みとなっています。
              <br />
              「残価」とは、リース契約が満了した時点で車両にどれくらいの価値が残っているかを予測した金額のことです。
              <br />
              車両本体価格から残価を差し引くことで、月々の支払額を抑えることが可能になります。
            </p>
          </div>
        </div>

        <div className={stylesOverview.carleaseOverviewButtonContainer}>
          <a
            className={`${stylesOverview.carleaseOverviewButtonItem} button radius-most is-large is-fixed-width-button`}
            href="/docs/about/"
          >
            定額カルモくんの特徴を解説
            <span
              className={`is-small icon-arrow has-background-black ${styles.topLinkIconArrow} ${styles.top_small_size}`}
            />
          </a>
          <a
            className={`${stylesOverview.carleaseOverviewButtonItem} button radius-most is-large is-fixed-width-button`}
            href="/lineup/"
          >
            新車を探す
            <span
              className={`is-small icon-arrow has-background-black ${styles.topLinkIconArrow} ${styles.top_small_size}`}
            />
          </a>
        </div>
      </div>
    </div>
  </section>
);

export default CarleaseOverview;
